const getSsoConfig = (domain: string, entraClientId: string, keyenceClientId = entraClientId) => {
  const getProviderConfig = (clientId: string) => ({
    oauth: {
      clientId,
      domain,
      responseType: 'code',
      scope: ['email', 'openid', 'phone'],
    },
    userPoolWebClientId: clientId,
  });

  return {
    entraid: getProviderConfig(entraClientId),
    keyence: getProviderConfig(keyenceClientId),
  };
};

const STG = {
  apiUrl: 'https://rst.stg.rask.ai',
  auth: {
    region: 'us-west-2',
    userPoolId: 'us-west-2_cTUc2QCj0',
    userPoolWebClientId: '7q7rlsnqoq410jmq76vr46j5j0',
  },
  baseUrl: 'https://app.stg.rask.ai',
  greenApiUrl: 'https://green-rst.stg.rask.ai',
  oauth: {
    clientId: '7q7rlsnqoq410jmq76vr46j5j0',
    domain: 'rask-stg.auth.us-west-2.amazoncognito.com',
  },
  sso: getSsoConfig('rask-stg.auth.us-west-2.amazoncognito.com', 'map3n0j1l4rlk0vkadotf82gs'),
};

const STG_WHITE = {
  apiUrl: 'https://rst.stg.videotranslationtool.com',
  auth: {
    region: 'us-west-2',
    userPoolId: 'us-west-2_cTUc2QCj0',
    userPoolWebClientId: '7q7rlsnqoq410jmq76vr46j5j0',
  },
  baseUrl: 'https://app.stg.videotranslationtool.com',
  greenApiUrl: 'https://green-rst.stg.videotranslationtool.com',
  oauth: {
    clientId: '7q7rlsnqoq410jmq76vr46j5j0',
    domain: 'rask-stg.auth.us-west-2.amazoncognito.com',
  },
  sso: getSsoConfig('rask-stg.auth.us-west-2.amazoncognito.com', 'map3n0j1l4rlk0vkadotf82gs'),
};

const PROD = {
  apiUrl: 'https://rst.rask.ai',
  auth: {
    region: 'us-east-2',
    userPoolId: 'us-east-2_39TxAbWNH',
    userPoolWebClientId: '3l205dqshftlhc51jbgppfe68n',
  },
  baseUrl: 'https://app.rask.ai',
  greenApiUrl: 'https://green-rst.rask.ai',
  oauth: {
    clientId: '3l205dqshftlhc51jbgppfe68n',
    domain: 'rask-prod.auth.us-east-2.amazoncognito.com',
  },
  sso: getSsoConfig(
    'rask-prod.auth.us-east-2.amazoncognito.com',
    '3lu20dtjmhsvg6i4752poq8mgs',
    '23748c4ernvvjjbk9ucr1ev30e',
  ),
};

const PROD_WHITE = {
  apiUrl: 'https://rst.videotranslationtool.com',
  auth: {
    region: 'us-east-2',
    userPoolId: 'us-east-2_39TxAbWNH',
    userPoolWebClientId: '3l205dqshftlhc51jbgppfe68n',
  },
  baseUrl: 'https://app.videotranslationtool.com',
  greenApiUrl: 'https://green-rst.videotranslationtool.com',
  oauth: {
    clientId: '3l205dqshftlhc51jbgppfe68n',
    domain: 'rask-prod.auth.us-east-2.amazoncognito.com',
  },
  sso: getSsoConfig(
    'rask-prod.auth.us-east-2.amazoncognito.com',
    'map3n0j1l4rlk0vkadotf82gs',
    '23748c4ernvvjjbk9ucr1ev30e',
  ),
};

const QA = {
  apiUrl: 'https://rst.qa.rask.ai',
  auth: {
    region: 'us-east-2',
    userPoolId: 'us-east-2_eQDWuM1cu',
    userPoolWebClientId: '356jh72oltgshmuu7m2rkgqa9v',
  },
  baseUrl: 'https://app.qa.rask.ai',
  greenApiUrl: 'https://green-rst.qa.rask.ai',
  oauth: {
    clientId: '356jh72oltgshmuu7m2rkgqa9v',
    domain: 'rask-qa.auth.us-east-2.amazoncognito.com',
  },
  sso: getSsoConfig('rask-qa.auth.us-east-2.amazoncognito.com', '2urp91ev195sans2omll2baqbj'),
};

const QA_WHITE = {
  apiUrl: 'https://rst.qa.videotranslationtool.com',
  auth: {
    region: 'us-east-2',
    userPoolId: 'us-east-2_eQDWuM1cu',
    userPoolWebClientId: '356jh72oltgshmuu7m2rkgqa9v',
  },
  baseUrl: 'https://app.qa.videotranslationtool.com',
  greenApiUrl: 'https://green-rst.qa.videotranslationtool.com',
  oauth: {
    clientId: '356jh72oltgshmuu7m2rkgqa9v',
    domain: 'rask-qa.auth.us-east-2.amazoncognito.com',
  },
  sso: getSsoConfig('rask-qa.auth.us-east-2.amazoncognito.com', '2urp91ev195sans2omll2baqbj'),
};

const TST = {
  apiUrl: 'https://rst.tst.rask.ai',
  auth: {
    region: 'us-east-2',
    userPoolId: 'us-east-2_mmFYFgkAs',
    userPoolWebClientId: 'o4quqk39pikfju8o44g50nutb',
  },
  baseUrl: 'https://app.tst.rask.ai',
  greenApiUrl: 'https://green-rst.tst.rask.ai',
  oauth: {
    clientId: 'o4quqk39pikfju8o44g50nutb',
    domain: 'rask-tst.auth.us-east-2.amazoncognito.com',
  },
  sso: getSsoConfig('rask-tst.auth.us-east-2.amazoncognito.com', 'map3n0j1l4rlk0vkadotf82gs'),
};

const TST_WHITE = {
  apiUrl: 'https://rst.tst.videotranslationtool.com',
  auth: {
    region: 'us-east-2',
    userPoolId: 'us-east-2_mmFYFgkAs',
    userPoolWebClientId: 'o4quqk39pikfju8o44g50nutb',
  },
  baseUrl: 'https://app.tst.videotranslationtool.com',
  greenApiUrl: 'https://green-rst.videotranslationtool.com',
  oauth: {
    clientId: 'o4quqk39pikfju8o44g50nutb',
    domain: 'rask-tst.auth.us-east-2.amazoncognito.com',
  },
  sso: getSsoConfig('rask-tst.auth.us-east-2.amazoncognito.com', 'map3n0j1l4rlk0vkadotf82gs'),
};

export const ENV_CONFIG = {
  PROD,
  PROD_WHITE,
  QA,
  QA_WHITE,
  STG,
  STG_WHITE,
  TST,
  TST_WHITE,
};
